const search = {
  addr_cds: '', // 地域で絞り込む
  railway_cds: '', // 沿線で絞り込む 沿線コード
  railway_names: '', // 沿線で絞り込む 沿線名

  contracted: 1, // 成約非表示
  tmp_save: 0, // 一時保存のみ

  vacancy_sort_from: null, // 確認日 始点
  vacancy_sort_to: null, // 確認日 終点

  id: '', // 物件ID(スペース区切りでor検索)
  control_no: '', // 物件管理番号
  matter_no: '', // 案件No
  property_name: '', // 物件名またはカナ
  room_no: '', // 部屋番号
  address_str: '', // 住所
  address_else1: '', // 住居表示
  station_name: '', // 駅名

  // 詳細検索
  m_b_type: [], // 物件種別
  mi_sale_state: null, // 販売状態
  m_vacant_type: null, // 現況
  f_owner_change: 0, // オーナーチェンジ
  b_price_from: null, // 物件価格 始点
  b_price_to: null, // 物件価格 終点
  yield_from: null, // 満室時利回り 始点
  yield_to: null, // 満室時利回り 終点
  income_price_from: null, // 満室時年間収入 始点
  income_price_to: null, // 満室時年間収入 終点
  magnification_from: null, // 倍率（軍用地) 始点
  magnification_to: null, // 倍率（軍用地) 終点
  line_1: '', // 沿線名1
  line_1_name: '', // 沿線名1
  line_1_cd_name: '', // 沿線1 沿線コード + 沿線名
  station_1: '', // 駅名1 始点
  station_end_1: '', // 駅名1 終点
  line_2: '', // 沿線名2
  line_2_name: '', // 沿線名1
  line_2_cd_name: '', // 沿線2 沿線コード + 沿線名
  station_2: '', // 駅名2 始点
  station_end_2: '', // 駅名2 終点
  line_3: '', // 沿線名3
  line_3_name: '', // 沿線名1
  line_3_cd_name: '', // 沿線3 沿線コード + 沿線名
  station_3: '', // 駅名3 始点
  station_end_3: '', // 駅名3 終点
  walk_minutes_from: '', // 駅徒歩 始点
  walk_minutes_to: '', // 駅徒歩 終点
  bus_stop: '', // バス停名
  water_supply_type: [], // 上水道
  sewerage_type: [], // 下水道
  gas_type: [], // ガス
  f_power_source: 0, // 動力電源
  f_electricity: 0, // 電気
  f_all_electrification: 0, // オール電化
  rank: [], // ランク
  list_star: [], // ☆マーク
  transaction_form: [], // 取引形態
  eacompany_name: '', // 元付業者名
  eacompany_tel: '', // 元付業者TEL
  eacompany_id: null, // 元付業者ID
  image_num_from: null, // 画像数 始点
  image_num_to: null, // 画像数 終点
  panorama_num_from: null, // パノラマ画像数 始点
  panorama_num_to: null, // パノラマ画像数 終点
  f_video_url: 0, // 動画URL
  charge_person: '', // 担当者1
  listing_charge_person: '', // 掲載用担当者
  created_at_from: '', // 作成日 始点
  created_at_to: '', // 作成日 終点
  updated_at_from: '', // 更新日 始点
  updated_at_to: '', // 更新日 終点
  last_updated_person: '', // 最終更新者
  room_charge_shop_list: [], // 担当店舗
  f_event_comment: 0, // イベントコメント
  total_freetag_search_type: 1, // フリータグ条件 AND or OR
  freetag_search_word_1: '', // フリータグ1
  freetag_search_type_1: 1,
  freetag_search_word_2: '', // フリータグ2
  freetag_search_type_2: 1,
  freetag_search_word_3: '', // フリータグ3
  freetag_search_type_3: 1,
  freetag_search_word_4: '', // フリータグ4
  freetag_search_type_4: 1,
  freetag_search_word_5: '', // フリータグ5
  freetag_search_type_5: 1,
  elementary_school: '', // 小学校
  junior_high_school: '', // 中学校

  summary: [], // 掲載サマリー
  summary_type: 'or', // 掲載サマリー 検索タイプ

  per_page: 20, // 表示件数
  sort: '-id', // ソート
  page: 1, // ページ
}

export default search
